import { PRODUCT_URL, PRODUCT_APP_ID, PRODUCT_APP_SECRET, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const locationCategoryAxiosInstaceV1 = axios.create({
    baseURL: `${PRODUCT_URL}/api/v1`,
    headers: {
        'app-id': PRODUCT_APP_ID,
        'app-secret': PRODUCT_APP_SECRET
    }
})
locationCategoryAxiosInstaceV1.interceptors.response.use(function (response) {
    if (response.data.redirect_to) {
        location.href = response.data.redirect_to
    }
    return response
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
        EventBus.$emit('unauthorized')
    }
    if (error.response.status !== 404) {
        EventBus.$emit('show-error-modal', error)
    }
    return Promise.reject(error)
})
export const LocationCategoryAPI = {
    /**
     * Fetch data
     */
    fetch(locationId) {
        return locationCategoryAxiosInstaceV1({
            method: 'get',
            url: `/locationCategories/${locationId}/getAll`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Insert data
     */
    insert(collection) {
        return locationCategoryAxiosInstaceV1({
            method: 'post',
            url: `/locationCategories`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Edit data
     */
    edit(id, collection) {
        return locationCategoryAxiosInstaceV1({
            method: 'post',
            url: `/locationCategories/${id}`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Delete api
     */
    delete(id) {
        return locationCategoryAxiosInstaceV1({
            method: 'delete',
            url: `/locationCategories/${id}`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * Get featured category api
     */
    getFeaturedCategory(locationProductId) {
        return locationCategoryAxiosInstaceV1({
            method: 'get',
            url: `/locationProducts/${locationProductId}/getFeaturedCategories`,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * save featured category api
     */
    syncFeaturedCategory(collection) {
        return locationCategoryAxiosInstaceV1({
            method: 'post',
            url: `/locationProducts/syncFeaturedCategories`,
            data: collection,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * get featured product
     */
    getFeaturedProduct(data) {
        return locationCategoryAxiosInstaceV1({
            method: 'get',
            url: `/locationProducts/${data}`,
            params: {
                status: 1,
                available: 'all',
                include_cannabis_attributes: 1,
                include_images: 1,
                include_terpenes: 1,
                include_thc_cbd: 1,
                include_variants: 1,
                include_brands: 1,
                include_location_product_category: 1
            },
            headers: {
                'auth-token': authToken()
            }
        })
    },
    /**
         * save featured category api
         */
    setInventoryThreshold(data) {
        return locationCategoryAxiosInstaceV1({
            method: 'post',
            url: `/locationCategories/variant/updateInventory`,
            data: data,
            headers: {
                'auth-token': authToken()
            }
        })
    },
    /**
         * save product family api
         */
    SetProductFamily(data) {
        return locationCategoryAxiosInstaceV1({
            method: 'post',
            url: `/locationCategories/updateProductFamily`,
            data: data,
            headers: {
                'auth-token': authToken()
            }
        })
    },

    /**
     * fetching products and category
     */
    fetchCategoryProducts(locationId, params) {
        return locationCategoryAxiosInstaceV1({
            method: 'get',
            url: `/locationCategories/${locationId}/location`,
            headers: {
              'auth-token': authToken()
            },
            params: params
        })
    }
}
